import {Component, OnInit} from "@angular/core";
import { Observable, of } from "rxjs";
import {AuthManagerService} from "../../auth/auth-manager.service";
import {MessageService} from "../../utils/message/message.service";
import {MatDialog} from "@angular/material/dialog";
import {HomeFirefoxDialogComponent} from "../home-firefox-dialog/home-firefox-dialog.component";
import {CartService} from "../../utils/cart/cart.service";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  isUser: Observable<boolean>;

  constructor(
    private authManagerService: AuthManagerService,
    public dialog: MatDialog,
    public cartService: CartService,
    private message: MessageService) {
  }

  ngOnInit(): void {
    this.isUser = this.authManagerService.isAccountPresent$;
    this.cartService.fetchCartItems();
    /* firefox dialog
    if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
      this.openFirefoxDialog();
    }
    */
  }

  handleLoggedIn() {
    this.isUser = of(true);
  }

  handleLoggedOut() {
    this.isUser = of(false);
  }

  openFirefoxDialog(): void {
    const dialogRef = this.dialog.open(HomeFirefoxDialogComponent, {
      width: '320px'
    });
    dialogRef.afterClosed().subscribe(result => {});
  }
}
